type ItemWithDisplayName = {
  displayName?: string;
  name: string;
};

/**
 * displayName 또는 name 기준으로 항목을 가나다순 정렬합니다.
 * - displayName 우선 사용, 없으면 name 사용
 * - 한글, 영문, 숫자 혼합 시 자연스러운 정렬 (localeCompare)
 * - 대소문자 구분 없이 정렬 (sensitivity: 'base')
 * - 숫자는 자연스러운 순서로 정렬 (numeric: true)
 */
export const sortByDisplayName = <T extends ItemWithDisplayName>(items: T[]): T[] => {
  return [...items].sort((a, b) => {
    const aLabel = a.displayName || a.name;
    const bLabel = b.displayName || b.name;
    return aLabel.localeCompare(bLabel, 'ko', { sensitivity: 'base', numeric: true });
  });
};
